import { createTranslations } from '@npco/common-utils-translations'

export const freeTrialInfoBoxTranslations = createTranslations({
  freeTrialEnds:
    'Free trial for this card ends on 1 April 2024 (and then $9 / card per month thereafter).',
})
